import { Combobox } from "@headlessui/react";
import { CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";

export default function SearchBar(props) {
    const [people, setPeople] = useState(props.customerList || []);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);
    const [query, setQuery] = useState("");
    const [filteredPeople, setFilteredPeople] = useState([]);

    useEffect(() => {
        if (!people.length) setPeople(props.customerList || []);
        else {
            if (query === "") {
                setFilteredPeople([]);
            } else {
                if (query.length < 2) {
                    setFilteredPeople([]);
                    return;
                } else {
                    const filtered = people.filter(
                        (person) =>
                            person.name &&
                            person.name
                                .toLowerCase()
                                .replace(/\s+/g, "")
                                .includes(query.toLowerCase().replace(/\s+/g, ""))
                    );
                    setFilteredPeople(filtered);

                    if (selected && selected !== props.selected) {
                        // setTimeout(() => {
                        setLoading(true);
                        search({ preventDefault: () => {} });
                        // }, 500);
                    }
                }
            }
        }

        if (props) setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, props, selected]);

    function search() {
        props.setLoading(true);
        props.setSelected(selected);

        // Update URL with customer id
        if (selected?.id) {
            const url = new URL(window.location);
            url.searchParams.set("id", selected.id);
            window.history.pushState({}, "", url);
        }

        // Filter people based on the query
        const filteredPeople = people.filter((person) => {
            if (person && person.name && query) {
                const name = String(person.name).toLowerCase().replace(/\s+/g, "");
                const queryLowerCase = query.toLowerCase().replace(/\s+/g, "");
                return name.includes(queryLowerCase);
            }
            return false;
        });

        setFilteredPeople(filteredPeople);
        setSelected(null);
        setQuery("");
        setLoading(false);
    }

    const clearSelection = () => {
        props.setSelected(null);
        setQuery("");
        setFilteredPeople([]);
    };

    return (
        <Combobox value={selected} onChange={setSelected} className="flex w-full max-w-[450px]">
            <div className="mt-1 md:mt-0">
                <div className="relative w-full cursor-default overflow-hidden rounded-xl shadow-md">
                    {!loading ? (
                        <div className="flex items-center justify-between">
                            <Combobox.Input
                                className="ngShadow relative w-full rounded-xl border-none py-2 pl-3 text-sm leading-5 text-gray-900"
                                onChange={(event) => setQuery(event.target.value)}
                                value={query}
                                placeholder={
                                    props.selected && props.selected.name
                                        ? props.selected.name
                                        : "Search customers..."
                                }
                                autoComplete="off"
                            />

                            {props.selected ? (
                                <XMarkIcon
                                    className="mx-2 h-6 w-6 cursor-pointer"
                                    aria-hidden="true"
                                    onClick={clearSelection}
                                />
                            ) : null}
                        </div>
                    ) : (
                        <h5 className="text-center">Loading...</h5>
                    )}
                </div>

                <Combobox.Options className="absolute mt-12 max-h-60 max-w-80 overflow-y-auto overflow-x-hidden rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                    {filteredPeople && filteredPeople.length === 0 && query && query.length < 2 ? (
                        <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                            <em>Minimum 2 characters required</em>
                        </div>
                    ) : filteredPeople &&
                      filteredPeople.length === 0 &&
                      query &&
                      query.length >= 2 ? (
                        <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                            <em>Nothing found.</em>
                        </div>
                    ) : filteredPeople && filteredPeople.length > 0 ? (
                        filteredPeople.map((person) => (
                            <Combobox.Option
                                key={person.id}
                                className={({ active }) =>
                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                                        active ? "active" : "text-gray-900"
                                    }`
                                }
                                value={person}
                            >
                                {({ selected, active }) => (
                                    <>
                                        <span
                                            className={`block truncate ${
                                                selected ? "font-medium" : "font-normal"
                                            }`}
                                        >
                                            {person.name}
                                        </span>
                                        {selected ? (
                                            <span
                                                className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                                                    active ? "text-white" : "text-teal-600"
                                                }`}
                                            >
                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                        ) : null}
                                    </>
                                )}
                            </Combobox.Option>
                        ))
                    ) : null}
                </Combobox.Options>
            </div>
        </Combobox>
    );
}
